import { z } from 'zod';
export const ssoDomainsGuard = z.array(z.string());
export const ssoBrandingGuard = z.object({
    displayName: z.string().optional(),
    logo: z.string().optional(),
    darkLogo: z.string().optional(),
});
